var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "overflow": "hidden",
      "height": "700px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.srTrackingUrl,
      "title": "Title of the page",
      "frameborder": "0",
      "height": "100%",
      "width": "100%"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62586b20","hasScoped":true}!./src/views/components/srTrackingWeb/srTrackingWeb.component.html
// module id = 1566
// module chunks = 1